import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

/** True for the platform operator (SuperAdmin). Reads the cached session. */
export function useIsOperator(): boolean {
  const { data } = useQuery({ queryKey: ['me'], queryFn: api.auth.me, staleTime: 60_000 })
  return data?.user.role === 'SuperAdmin'
}

/**
 * A From address on one of the account's verified sending domains: local part + domain.
 * Customer campaigns and list confirmations send from here through the platform.
 */
export function FromAddressPicker({ value, onChange, id }: { value: string; onChange: (v: string) => void; id?: string }) {
  const { data } = useQuery({ queryKey: ['domains'], queryFn: api.domains.list })
  const verified = (data?.data ?? []).filter(d => d.can_send).map(d => d.name)
  const [local, setLocal] = useState(() => value.split('@')[0] ?? '')
  const [domain, setDomain] = useState(() => value.split('@')[1] ?? '')

  // Default to the first verified domain once they load.
  useEffect(() => { if (!domain && verified.length) setDomain(verified[0] ?? "") }, [verified.length]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { onChange(local && domain ? `${local.trim().toLowerCase()}@${domain}` : '') }, [local, domain]) // eslint-disable-line react-hooks/exhaustive-deps

  if (data && verified.length === 0) {
    return <div className="small muted">No verified sending domain yet. <Link to="/domains">Add and verify a domain</Link> first.</div>
  }
  return (
    <div className="row" style={{ gap: 6, alignItems: 'center' }}>
      <input id={id} value={local} onChange={e => setLocal(e.target.value.replace(/[@\s]/g, ''))} placeholder="news" style={{ flex: '1 1 120px' }} />
      <span className="muted">@</span>
      <select value={domain} onChange={e => setDomain(e.target.value)} style={{ flex: '1 1 160px' }}>
        {verified.map(d => <option key={d} value={d}>{d}</option>)}
      </select>
    </div>
  )
}
